import React from "react"

const Progress = ({ value }) => {
  const percent = parseInt(value)
  return (
    <div>
      <div class="relative pt-1">
        {/* <div class="flex mb-2 items-center justify-between">
          <div>
            <span class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blue-600 bg-blue-200">
              Task in progress
            </span>
          </div>
          <div class="text-right">
            <span class="text-xs font-semibold inline-block text-green-600">
              {percent}%
            </span>
          </div>
        </div> */}

        <div class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-green-200">
          <div
            style={{ width: `${percent}%` }}
            className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-green-500"
          />
        </div>
      </div>
    </div>
  )
}

export default Progress
